export default __webpack_public_path__ + "static/media/Fishing-with-Karin.3feb3c23.jpg";